import { render, staticRenderFns } from "./Item-delivery-ranking-center.vue?vue&type=template&id=77833c3f&scoped=true&lang=pug"
import script from "./Item-delivery-ranking-center.vue?vue&type=script&lang=js"
export * from "./Item-delivery-ranking-center.vue?vue&type=script&lang=js"
import style0 from "./Item-delivery-ranking-center.vue?vue&type=style&index=0&id=77833c3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77833c3f",
  null
  
)

export default component.exports